import { useEffect, useState } from 'react'
import { Modal, Row, Col } from 'react-bootstrap'
import { StyledAddressModal } from './AddressModal.styled'
import { Button, FormControl as Input } from 'react-bootstrap'
import { Form, Formik } from 'formik'
import { IAddressForm, initialAddressValue, addressValidateSchema } from 'types/Grounding/groundingTypes'
import { StyledModal } from 'components/Modal.styled'
import { AddressTypes, GENERAL_ERROR_MESSAGE, SaveLocationOption } from 'common/constants'
import { DropdownList } from 'layouts/DropdownList'
import { DropDownData, LocationDropDown } from 'types/Grounding/GroundingResult'
import { ValidationErrorMessage } from 'components/Forms'
interface IAddressProps {
  defaultAddressDetail: LocationDropDown
  stateList: DropDownData[]
  show: boolean
  isEditAddress: boolean
  events: {
    onClose: any
    handleSaveAddress: any
    setIsSaveAddressToBuyer: any
  }
}

export const AddressModal = ({ defaultAddressDetail, isEditAddress, stateList, show, events }: IAddressProps) => {
  const [isSubmit, setIsSubmit] = useState(false)
  const [addressDetail] = useState<LocationDropDown>(defaultAddressDetail)
  const [saveOptionSelected, setSaveOptionSelected] = useState(0)
  const [initLocationData, setInitLocationData] = useState<IAddressForm>(initialAddressValue)

  useEffect(() => {
    if (defaultAddressDetail != null) {
      setInitLocationData({
        address: defaultAddressDetail.Address1,
        address2: defaultAddressDetail.Address2,
        city: defaultAddressDetail.City,
        zip: defaultAddressDetail.Zip,
        stateCode: defaultAddressDetail?.StateCode
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const handleSaveAddress = (values: IAddressForm) => {
    if (saveOptionSelected === 0 && !isEditAddress) {
      return
    }

    events.handleSaveAddress({
      AddressLineOne: values.address,
      AddressLineTwo: values.address2,
      Town: values.city,
      StateId: stateList?.find((x) => x.FieldDescription === values.stateCode)?.ID ?? 0,
      PostCode: values.zip,
      AddressId:
        isEditAddress && defaultAddressDetail?.AddressTypeID != AddressTypes.HEAD_OFFICE ? defaultAddressDetail?.ID : 0,
      AddressTypeId:
        isEditAddress && defaultAddressDetail?.AddressTypeID != AddressTypes.HEAD_OFFICE
          ? defaultAddressDetail?.AddressTypeID
          : AddressTypes.VEHICLE_PICKUP_LOCATION
    })
  }

  const handleSaveOptionChange = (e: any) => {
    setSaveOptionSelected(Number(e.target.id))
    if (Number(e.target.id) === SaveLocationOption.SAVE_TO_BUYER) {
      events.setIsSaveAddressToBuyer(true)
    } else {
      events.setIsSaveAddressToBuyer(false)
    }
  }

  return (
    <StyledModal show={show} onHide={events.onClose} backdrop="true" centered customWidth={'550px'}>
      <StyledAddressModal>
        <Modal.Header closeButton>
          <Modal.Title>Vehicle Location</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Formik
            enableReinitialize
            initialValues={initLocationData}
            validationSchema={addressValidateSchema}
            onSubmit={(values) => handleSaveAddress(values)}
            validateOnBlur={false}
          >
            {(props) => (
              <Form>
                <div>
                  <label className="required-field">Address</label>
                  <Input
                    name="address"
                    defaultValue={addressDetail?.Address1}
                    isInvalid={isSubmit && !!props.errors?.address}
                    onChange={props.handleChange}
                    value={props.values?.address}
                  />
                  <ValidationErrorMessage>{!!props.errors?.address && props.errors?.address}</ValidationErrorMessage>
                </div>
                <div>
                  <label>Address 2</label>
                  <Input
                    name="address2"
                    defaultValue={addressDetail?.Address2}
                    onChange={props.handleChange}
                    value={props.values?.address2}
                  />
                  <p className="error-label"></p>
                </div>
                <Row>
                  <Col sm={6}>
                    <div>
                      <label className="required-field">City</label>
                      <Input
                        name="city"
                        defaultValue={addressDetail?.City}
                        isInvalid={isSubmit && !!props.errors?.city}
                        onChange={props.handleChange}
                        value={props.values?.city}
                      />
                      <ValidationErrorMessage>{!!props.errors?.city && props.errors?.city}</ValidationErrorMessage>
                    </div>
                  </Col>
                  <Col sm={6}>
                    <div>
                      <label className="required-field">State</label>
                      <DropdownList
                        defaultValue={addressDetail?.StateCode || '-1'}
                        items={[
                          { id: '-1', value: 'Choose...' },
                          ...stateList?.map((item) => ({
                            id: item?.FieldDescription?.toString(),
                            value: item?.Description
                          }))
                        ]}
                        onChange={(id) => props.setFieldValue('stateCode', id)}
                      />
                      <ValidationErrorMessage>
                        {!!props.errors?.stateCode && props.errors?.stateCode}
                      </ValidationErrorMessage>
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col sm={6}>
                    <div>
                      <label className="required-field">Zip</label>
                      <Input
                        name="zip"
                        maxLength={5}
                        defaultValue={addressDetail?.Zip}
                        isInvalid={isSubmit && !!props.errors?.zip}
                        onChange={props.handleChange}
                        value={props.values?.zip}
                      />
                      <ValidationErrorMessage>{!!props.errors?.zip && props.errors.zip}</ValidationErrorMessage>
                    </div>
                  </Col>
                </Row>

                {!isEditAddress && (
                  <Row className="save-option">
                    <Col sm={12}>
                      <input
                        type="radio"
                        name="saveOption"
                        id="1"
                        checked={saveOptionSelected === 1}
                        onChange={(e) => handleSaveOptionChange(e)}
                      />
                      <label htmlFor="1">Save and Add to My Locations</label>
                    </Col>
                    <Col sm={12}>
                      <input
                        type="radio"
                        name="saveOption"
                        id="2"
                        checked={saveOptionSelected === 2}
                        onChange={(e) => handleSaveOptionChange(e)}
                      />
                      <label htmlFor="2">Save and Do not add to My Locations</label>
                    </Col>
                    <Col sm={12}>
                      <ValidationErrorMessage>
                        {isSubmit && saveOptionSelected === 0 && 'Please select an option'}
                      </ValidationErrorMessage>
                    </Col>
                  </Row>
                )}

                <div className="btn-group">
                  <Button type="submit" variant="primary" onClick={() => setIsSubmit(true)}>
                    Save
                  </Button>
                  <Button type="cancel" className="btn-secondary" onClick={events.onClose}>
                    Cancel
                  </Button>
                </div>
              </Form>
            )}
          </Formik>
        </Modal.Body>
      </StyledAddressModal>
    </StyledModal>
  )
}
